import { gateway } from "../../../../gateway";

interface Props {
  jobId: number | string;
  alias: string | null;
}

export const updateJobAlias = async ({ jobId, alias }: Props) => {
  try {
    const token = sessionStorage.getItem("token");

    const res = await gateway.patch(
      `/jobs/self/${jobId}`,
      {
        alias,
      },
      {
        headers: {
          Authorization: `${token}`,
        },
      },
    );

    return res.data?.data || res.data;
  } catch (error) {
    throw error;
  }
};
